import { useEffect, useRef } from 'react';

import { useClassContext } from '../../../../Context';
import { generateBackground } from './helpers';

const useBackground = () => {
  const { cls } = useClassContext();

  const svgRef = useRef<SVGSVGElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const numNodes = cls?.attendanceInProgress?.nowMarkedPresent ?? 0;

  useEffect(() => {
    if (!inputRef.current) return;
    inputRef.current.dispatchEvent(new Event('change'));
  }, [numNodes]);

  useEffect(() => {
    if (!svgRef.current) return;
    if (!inputRef.current) return;
    const timerId = generateBackground(svgRef, inputRef);
    return function cleanup() {
      clearInterval(timerId);
    };
  }, []);

  return { svgRef, inputRef, numNodes };
};

export default useBackground;
